import type {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T327156-skip-ai-pjp-flow': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'T327256-email-verify-otp-noop': 'control',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T90189-image-thumbnail-service': 'control',
  webapp_playground_test: 'control',
  'T195472-web-push-notifications': 'control',
  'T281208-group-search-by-name': 'control',
  'T308216-newsfeed-project-bids-noop': 'control',
  'T322080-prompt-2fa-upsell-noop': 'control',
  'T311153-only-show-recurable-payment-methods-for-monthly-membership':
    'Control',
  'T314575-pjp-email-and-phone-verify-redesign-v5': 'control',
  'T331317-indian-mandate-membership': 'control',
  'T332502-navigation-tabs': 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
